import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, SearchX, MessageSquareOff, HandCoins, Sparkles, Percent } from "lucide-react";
import { Section, SectionHeading, Eyebrow, GlassCard, Reveal } from "../components/ui-shared";

const values = [
  { t: "STOP SEARCHING", d: "Spend less time manually discovering creators.", icon: SearchX },
  { t: "STOP CHASING", d: "Reduce endless DMs and follow-ups.", icon: MessageSquareOff },
  { t: "STOP PAYING MIDDLEMEN", d: "Keep the process directly in your hands.", icon: HandCoins },
  { t: "START DISCOVERING", d: "Use campaign and performance information to make more informed decisions.", icon: Sparkles },
];

export default function Businesses() {
  return (
    <div>
      <section className="pt-16 sm:pt-24 pb-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="max-w-3xl">
            <Eyebrow>For Businesses</Eyebrow>
            <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05] text-white">
              STOP CHASING CREATORS.
            </h1>
            <p className="mt-6 text-base sm:text-lg text-slate-300 leading-relaxed max-w-xl">
              Post your campaign. Define what you need. Let Orbit help surface relevant creator profiles based on your requirements and budget.
            </p>
            <Link to="/business-apply" className="btn-primary mt-8">Apply for Business Beta <ArrowRight size={18} /></Link>
          </motion.div>
        </div>
      </section>

      <Section>
        <div className="grid gap-5 sm:grid-cols-2">
          {values.map((v, i) => (
            <Reveal key={v.t} delay={i * 0.08}>
              <GlassCard className="p-7 h-full">
                <span className="grid place-items-center h-11 w-11 rounded-xl bg-sky-500/15 border border-sky-400/25 text-sky-300">
                  <v.icon size={19} />
                </span>
                <h3 className="mt-5 font-display text-lg font-semibold text-white">{v.t}</h3>
                <p className="mt-2 text-sm text-slate-400 leading-relaxed">{v.d}</p>
              </GlassCard>
            </Reveal>
          ))}
        </div>
      </Section>

      {/* BUSINESS PRIVATE BETA */}
      <Section className="!pt-4 !pb-28">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl glass p-8 sm:p-14">
            <div className="absolute inset-0 -z-10 opacity-80"
              style={{ background: "radial-gradient(ellipse at 20% 0%, rgba(99,102,241,0.22), transparent 60%)" }} />
            <span className="pill">
              <Percent size={13} /> Private Beta is live
            </span>
            <h2 className="mt-6 font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-white">
              TRY ORBIT. ZERO PLATFORM FEE.
            </h2>
            <p className="mt-5 max-w-2xl text-base text-slate-300 leading-relaxed">
              We're currently onboarding a limited group of businesses into our Private Beta. Test Orbit with real
              campaigns and real creator discovery with 0% platform fee during the beta.
            </p>
            <p className="mt-4 max-w-2xl text-base text-slate-200 font-medium">
              If Orbit doesn't work for your campaign, you don't pay us a platform fee.
            </p>
            <p className="mt-3 max-w-2xl text-xs text-slate-500 font-mono">
              Note: 0% platform fee refers to the platform fee during the beta. Access may require a beta token — this is
              separate from the platform fee.
            </p>
            <Link to="/business-apply" className="btn-primary mt-8">Request Business Access <ArrowRight size={18} /></Link>
          </div>
        </Reveal>
      </Section>
    </div>
  );
}
